export const getOrCreateHiddenInput = (form: Element, name: string): HTMLInputElement => {
  const result = Array.from(document.getElementsByName(name));
  if (result.length > 0) {
    return result[0] as HTMLInputElement;
  }

  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.name = name;
  form.appendChild(hiddenInput);
  return hiddenInput;
};
